import { numberConvert } from "@website/utils/number-convert";

export const displayPercentageDiscount = (price: number, priceOff: number) =>
  `٪${numberConvert(Math.ceil(((price - priceOff) * 100) / price).toFixed(0), {
    locale: "fa"
  })}`;
